import { set, when } from 'cerebral/operators'
import checkLoggedIn from '../../user/actions/checkLoggedIn'
import dismissGDPR from './dismissGDPR'
import validateRegistrationStep from './validateRegistrationStep'
import acceptGDPR from '../actions/acceptGDPR'
import getFirstModule from '../actions/getFirstModule'
import changeModule from '../../user/chains/changeModule'

export default [
  set('state:login.showGDPRDialog', false),
  set('state:app.showAlreadyAgreedGDPRTerms', false),
  when('state:login.acceptedGDPR'),
  {
    true: [
      checkLoggedIn,
      {
        success: [
          acceptGDPR,
          {
            success: [
              when('state:app.redirectAfterGDPR'),
              {
                true: [
                  getFirstModule,
                  {
                    module: [...changeModule],
                    none: []
                  }
                ],
                false: []
              }
            ],
            error: []
          }
        ],
        error: [
          set('output:currentPage', 'common'),
          ...validateRegistrationStep
        ]
      }
    ],
    false: [
      checkLoggedIn,
      {
        success: [set('state:app.showUserNotAgreedOnDBPRTerms', true)],
        error: [...dismissGDPR]
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/modules/login/chains/closeGDPRDialog.js